export enum OrganizationStatusEnum {
    Active = 10,
    Pending = 11,
    Inactive = 12,
}

export enum OrganizationTypeEnum {
    MarineAgency = 31,
    PortAuthority = 13,
    RegisteredOwner = 15,
    BillableParty = 16,
    Charterer = 17,
    ShippingLine = 18,
    FerryService = 19,
    FuelSupplier = 20,
    TowingService = 22,
    Dredging = 23,
    ShipManager = 24,
    Consignee = 25,
    PIClub = 26,
    MarineAuthorityNavy = 27,
    //Terminal = 28,
    //Other = 29, will be removed soo
    //TugServiceProvider = 33, will be removed soon
    ClassificationSociety = 36,
    Operator = 37,
    Shipper = 51,
    WaiverHolder = 104,
    TerminalOperator = 106,

    //service providers
    BunkerService = 21,
    MooringService = 32,
    EngineImmobilizationService = 109,
    HotWorksAuthorizationService = 110,
    StowawayLandingService = 111,
    CargoHoldInspectionService = 112,
    ShiftWithoutPilotService = 113,
    FreshWaterService = 114,
    ElectricityService = 115,
    GangwayService = 116,
    MedicalConsultationService = 117,
    LifeboatTestService = 118,
    AnchorTestService = 119,
    DivingService = 120,
    PortVesselService = 121,
    PaintingService = 122,
    WasteRemovalService = 123,
    DesloppingService = 124,
    ScrubberService = 125,
    DeballastingService = 126,
    YardService = 127,
    OVIDInspectionService = 128,
    SpecialCargoRequestService = 129,
    PilotageService = 130,
    SharedBollardRequestService = 143,
    SafetyBrigadeService = 195,
    AirbridgeService = 225,
    SwimmingService = 2810,
    ROVDeploymentService = 2812,
    OtherServiceRequestService = 2813,
    //dynamic service providers
    EquipmentService = 10003,
    CraneHireService = 10020,
    CraneService = 10021,
    NonRoutineTowageService = 10022,
}

export enum OrganizationTypeStringEnum {
    PortAuthority = 'Port Authority',
    //VesselAgency = "Vessel Agency", will be removed soon
    RegisteredOwner = 'Registered Owner',
    BillableParty = 'Billable Party',
    Charterer = 'Charterer',
    ShippingLine = 'Shipping Line',
    //FerryService = "Ferry Service", will be removed soon
    FuelSupplier = 'Fuel Supplier',
    TowingService = 'Towing Service',
    Dredging = 'Dredging Service',
    ShipManager = 'Ship Manager',
    Consignee = 'Consignee',
    PIClub = 'P&I Club',
    MarineAuthorityNavy = 'Marine Authority (Navy)', //will be removed soon
    Terminal = 'Terminal Operator',
    //Other = "Other", will be removed soon
    LocalAgency = 'Local Agency',
    MarineAgency = 'Marine Agency',
    //TugServiceProvider = "Tug Service Provider", will be removed soon
    ClassificationSociety = 'Classification Society',
    Operator = 'Operator',
    WaiverHolder = 'Waiver Holder',
    TerminalOperator = 'Terminal Operator',

    //service providers
    BunkerService = 'Bunker Service',
    MooringService = 'Mooring Service',
    EngineImmobilizationService = 'Engine Immobilization Service',
    HotWorksAuthorizationService = 'Hot Works Authorization Service',
    StowawayLandingService = 'Stowaway Landing Service',
    CargoHoldInspectionService = 'Cargo Hold Inspection Service',
    ShiftWithoutPilotService = 'Shift Without Pilot Service',
    FreshWaterService = 'Fresh Water Service',
    ElectricityService = 'Electricity Service',
    GangwayService = 'Gangway Service',
    MedicalConsultationService = 'Medical Consultation Service',
    LifeboatTestService = 'Lifeboat Test Service',
    AnchorTestService = 'Anchor Test Service',
    DivingService = 'Diving Service',
    PortVesselService = 'Port Vessel Service',
    PaintingService = 'Painting Service',
    WasteRemovalService = 'Waste Removal Service',
    DesloppingService = 'Deslopping Service',
    ScrubberService = 'Scrubber Service',
    DeballastingService = 'Deballasting Service',
    YardService = 'Yard Service',
    OVIDInspectionService = 'OVID Inspection Service',
    SpecialCargoRequestService = 'Special Cargo Request Service',
    SharedBollardRequestService = 'Shared Bollard Request Service',
}

export enum OrganizationTabEnum {
    Default = 0,
    General = 1,
    Branches = 2,
    PaymentDetails = 3,
    Contacts = 5,
    Comments = 6,
    Documents = 7,
}

export enum OrganizationTabStringEnum {
    General = 'General',
    Address = 'Address',
    Branches = 'Branches',
    PaymentDetails = 'Payment Details',
    Contacts = 'Contacts',
    Comments = 'Comments',
    Documents = 'Documents',
}

export enum OrganizationRadioBtnEnum {
    USA = 1,
    Canada = 2,
}
